import { IStep } from "@models/ui-models/step";

export enum DiscretionaryTrustEstablishmentFormStepsEnum {
  FormDescription,
  TrustDetailsAndAddress,
  SettlorAndPrincipalAppointor,
  Trustees,
  Beneficiaries,
  AuthorisedSignatories,
}

export const DiscretionaryTrustEstablishmentFormSteps: IStep<DiscretionaryTrustEstablishmentFormStepsEnum>[] = [
  {
    label: 'Description',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.FormDescription
  },
  {
    label: 'Trust Details and Address',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.TrustDetailsAndAddress
  },
  {
    label: 'Settlor and Principal Appointor',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.SettlorAndPrincipalAppointor
  },
  {
    label: 'Trustees',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.Trustees
  },
  {
    label: 'Beneficiaries',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.Beneficiaries
  },
  {
    label: 'Authorised Signatory',
    step: DiscretionaryTrustEstablishmentFormStepsEnum.AuthorisedSignatories
  },
];
